import dayjs from "dayjs";

export default function DaySelect({
  weeksOfTheMonth,
  handleDateChange,
  handleDateClick,
  selectedDate,
  setSelectedDate,
  currentDay,
  actualSelectedDate,
  minDate,
  maxDate,
}) {
  const minDay = minDate ? dayjs(minDate).startOf("day") : null;
  const maxDay = maxDate ? dayjs(maxDate).startOf("day") : null;

  const isDayDisabled = (day) => {
    const d = dayjs(day).startOf("day");
    if (minDay && d.isBefore(minDay)) return true;
    if (maxDay && d.isAfter(maxDay)) return true;
    return false;
  };

  const baseCell =
    "h-[30px] w-[30px] m-[4px] flex items-center justify-center rounded-md";
  const disabledCell = `${baseCell} text-[#DAE1E7] cursor-not-allowed opacity-50 pointer-events-none`;
  const otherMonthCell = `${baseCell} cursor-pointer hover:bg-orange-50 text-[#DAE1E7]`;
  const selectedCell = `${baseCell} cursor-pointer bg-orange-400 hover:bg-orange-600 text-white`;
  const normalCell = `${baseCell} cursor-pointer hover:bg-orange-200 text-[#1B1B2F]`;

  return (
    <>
      <div className={"flex justify-between"}>
        {weeksOfTheMonth[0].map((day, index) => (
          <div
            className={"h-[30px] w-[30px] m-[2px] flex items-center justify-center text-[#9BA4B4]"}
            key={`week-day-${index}`}
          >
            {dayjs(day).format("dd")}
          </div>
        ))}
      </div>
      {weeksOfTheMonth.map((week, weekIndex) => (
        <div className={"flex"} key={`week-${weekIndex}`}>
          {week.map((day, dayIndex) => {
            const disabled = isDayDisabled(day);
            const otherMonth =
              selectedDate.clone().toDate().getMonth() !== day.getMonth();
            const isSelected = dayjs(day).isSame(actualSelectedDate, "date");
            let cellClass = normalCell;
            if (disabled) cellClass = disabledCell;
            else if (otherMonth) cellClass = otherMonthCell;
            else if (isSelected) cellClass = selectedCell;

            return (
              <div
                onClick={() => {
                  if (!disabled) {
                    handleDateChange(day);
                    handleDateClick?.(true);
                  }
                }}
                key={`day-${dayIndex}`}
                className={cellClass}
              >
                {day.getDate()}
              </div>
            );
          })}
        </div>
      ))}
      {(!minDay || !dayjs().startOf("day").isBefore(minDay)) && (
        <div
          className="text-center p-1 m-1 rounded-lg font-semibold text-white bg-orange-400 hover:bg-orange-600 cursor-pointer"
          onClick={() => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            handleDateChange(today);
            setSelectedDate(dayjs(today));
          }}
        >
          Today
        </div>
      )}
    </>
  );
}